interface BannerRibbonProps {
    text: string;
    color: string;
}

const BannerRibbon = ({ text, color }: BannerRibbonProps) => {
    return (
        <div style={{backgroundColor: color}} className="border py-2 mb-4 flex flex-col items-center justify-center h-10 w-full">
            <h2 className="font-bold text-white text-center">{text}</h2>
        </div>
    );
};
  
export default BannerRibbon;


